import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@components/Typography';

const RightPanel = ({ title, subtitle, onClose, children }) => (
    <Box
        sx={{
            width: 356,
            flexShrink: 0,
            borderLeft: '1px solid var(--divider)',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        }}
    >
        <Box
            sx={{
                p: 2.5,
                borderBottom: '1px solid var(--divider)',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 1,
            }}
        >
            <Box>
                <Typography variant="h6">{title}</Typography>
                {subtitle && (
                    <Typography variant="caption" color="textSecondary">
                        {subtitle}
                    </Typography>
                )}
            </Box>
            {onClose && <CloseIcon sx={{ cursor: 'pointer', color: 'var(--text-secondary)' }} onClick={onClose} />}
        </Box>
        <Box sx={{ p: 2.5, overflowY: 'auto', flex: 1 }}>{children}</Box>
    </Box>
);

export default RightPanel;
